"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXCLUDE_INTERNAL_REFERRERS_CONDITIONS = void 0;
exports.EXCLUDE_INTERNAL_REFERRERS_CONDITIONS = {
    always: 'always',
    ifEmptyCampaign: 'ifEmptyCampaign',
};
//# sourceMappingURL=browser-config.js.map